"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/keys"));
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
(function iconsEntry() {
  var importAll = function importAll(requirement) {
    (0, _keys.default)(requirement).call(requirement).forEach(requirement);
  };
  if (process.env.JUTRO_APP_CLIENT_ICONS_PATH) {
    importAll(require.context(process.env.JUTRO_APP_CLIENT_ICONS_PATH, true, /.*(gw|cust)-.*\.svg$/));
  }
  if (process.env.GW_ICONS_PATH) {
    importAll(require.context(process.env.GW_ICONS_PATH, true, /.*(gw|cust)-.*\.svg$/));
  }
})();
//# sourceMappingURL=iconsEntry.js.map